export const setSelectedServiceId = (params) => {
    return {
        type: 'setSelectedServiceId',
        payload: params,
    };
};

export const setSelectedStageId = (params) => {
    return {
        type: 'setSelectedStageId',
        payload: params,
    };
};

export const getCRCTaskPickerEmail = (params) => {
    return {
        type: 'getCRCTaskPickerEmail',
        payload: params,
    };
};

export const getcrcPickerEmail = (params) => {
    return {
        type: 'getcrcPickerEmail',
        payload: params,
    };
};


export const setSelectedImc = (params) => {
    return {
        type: 'setSelectedImc',
        payload: params,
    };
};

export const triggerUseEffect = (params) => {
    return {
        type: 'triggerUseEffect',
        payload: params,
    };
};


